<div class="d-flex flex-column justify-content-start align-items-start h-100 w-100">

    <div *ngIf="!approbations || approbations.length == 0" class="alert alert-info w-100" role="alert">
       <span>{{labels.emptyApprobationsMessage}}</span>
    </div>

    <div *ngIf="approbations && approbations.length > 0" class="w-100">

        <div *ngFor="let approbationType of approbationTypes" class="d-flex flex-column justify-content-start align-items-start w-100">

            <span class="fw-bolder mb-2">Autorizaciones {{approbationType}}:</span>
            <div *ngFor="let item of getApprobationsByType(approbationType)" class="w-100">

                <div class="d-flex flex-row justify-content-start align-items-start w-100 mb-2">

                    <p-checkbox
                        class="me-2"
                        [inputId]="item.approbation.approbationId.toString()"
                        [binary]="true"
                        [(ngModel)]="item.checked"
                        (onChange)="onCheckedApprobationChange($event, item)">
                    </p-checkbox>

                    <label [for]="item.approbation.approbationId.toString()">
                        <span>{{item.approbation.text}}</span>
                        <span *ngIf="item.approbation.isRequired" class="mb-2">(obligatoria)</span>
                    </label>

                </div>

            </div>

        </div>

    </div>

</div>
